module.exports = {
  platformSource: '平台渠道',
  creatDate: '异常工单创建时间',
  status: '异常工单状态',
  cause: '异常原因',
  returnNum: '退回快递单号',
  abnormalNum: '异常工单号',
  appendix: '附件',
  downloadCheckBox: '导出包含异常工单过程信息',
  exportResults: '导出结果',
  tableTitle: '更多明细请参考导出结果。点击工单号，可查看过程数据。',
  workStatus: '工单状态',
  workRegistrationTime: '工单创建时间',
  returnTrackingNum: '退回快递单号',
  exception: '异常原因',
  platformChannel: '平台渠道',
  omsReturnInstruction: 'OMS退货指令',
  platformReturnInstruction: '平台退货指令',
  abnormalWorkLineNum: '异常工单行号',
  productCode: '商品编码',
  size: '尺码',
  qualityResults: '质检结果',
  wmsHandleResult: 'WMS处理结果',
  wmsCloseTime: 'WMS关单时间',
  maxErrorTitle: '一次最多上传20行数据',
  placeholderFormat: '格式：\nXXXXXX\nXXXXXX',
  currentWorkStatus: '当前工单状态',
  shopName: '店铺名称',
  operatingTime: '操作时间',
  operationalState: '操作状态',
  lineName: '行号',
  abnormalCause: '异常原因',
  operator: '操作方',
  reveiver: '接收方',
  remark: '备注',
  isClose: '是否关闭',
  isVoided: '是否作废',
  operationalEvent: '操作事件',
  operationResult: '操作结果',
  history: '过程数据',
  csHandleType: 'CS处理意见',
  csHandleSubType: 'CS处理意见二级分类',
  gradeName: '质检结果',
  placeholderFormat2: '格式：\nXXXXXX-XXX\nXXXXXX-XXX\nXXXXXX-XXX'
}
